<template>
  <div>
    <v-dialog v-model="orderDialog" width="80%" @input="v => v || closeDialog()">
      <v-layout column>
        <v-list style="padding-top:0; padding-bottom: 0;">
          <template v-for="(item, index) in viewOrder">
            <v-list-tile
              :key="index"
              @click="{}"
            >
              <!--<v-list-tile-->
              <!--:style="`background: ${item.color}`"-->
              <!--:key="index"-->
              <!--@click="{}"-->
              <!--&gt;-->
              <v-list-tile-content
              >
                <v-list-tile-title v-html="item.name"></v-list-tile-title>
                <!--<v-list-tile-sub-title v-html="item.name"></v-list-tile-sub-title>-->
              </v-list-tile-content>
              <v-list-tile-action v-if="index +1 < viewOrder.length">
                <v-btn icon ripple @click="clickOrder(index, false)">
                  <v-icon>mdi-chevron-double-down</v-icon>
                </v-btn>
              </v-list-tile-action>
              <v-list-tile-action v-else>
                <v-btn disabled icon ripple>
                  <v-icon>mdi-chevron-double-down</v-icon>
                </v-btn>
              </v-list-tile-action>

              <v-list-tile-action v-if="index !== 0">
                <v-btn icon ripple @click="clickOrder(index, true)">
                  <v-icon>mdi-chevron-double-up</v-icon>
                </v-btn>
              </v-list-tile-action>
              <v-list-tile-action v-else>
                <v-btn disabled icon ripple>
                  <v-icon>mdi-chevron-double-up</v-icon>
                </v-btn>
              </v-list-tile-action>

            </v-list-tile>
            <v-divider v-if="index + 1 < viewOrder.length" :key="`divider-${index}`"></v-divider>
          </template>
        </v-list>
      </v-layout>
    </v-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import EventBus from '@/common/EventBus'

export default {
  data () {
    return {
      orderDialog: true,
      viewOrder: null
    }
  },
  methods: {
    closeDialog: function () {
      this.$router.history.go(-1)
      this.orderDialog = false
    },
    clickOrder (index, goingUp) {
      if (goingUp === true) {
        const tmp = this.viewOrder[index]
        Vue.set(this.viewOrder, index, this.viewOrder[index - 1])
        Vue.set(this.viewOrder, index - 1, tmp)
      } else {
        const tmp = this.viewOrder[index]
        Vue.set(this.viewOrder, index, this.viewOrder[index + 1])
        Vue.set(this.viewOrder, index + 1, tmp)
      }
      this.$cookie.set('viewOrder', JSON.stringify(this.viewOrder), { expires: '1Y' })
    }
  },
  created () {
    if (this.$route.params.viewOrder === undefined) {
      // press F5
      const defaultViewOrder = [
        {
          code: 'doorToDoor',
          name: 'CJ 대한통운',
          color: '#EFEBE9'
        }, {
          code: 'unipass',
          name: '관세청',
          color: '#ECEFF1'
        }, {
          code: 'epost',
          name: '우체국',
          color: '#FDF0F0'
        }, {
          code: 'asianaCargo',
          name: '아시아나 카고',
          color: '#EDE7F6'
        }, {
          code: 'hanjin',
          name: '한진',
          color: '#E0F2F1'
        }
      ]
      try {
        this.viewOrder = (this.$cookie.get('viewOrder') === null) ? defaultViewOrder : JSON.parse(this.$cookie.get('viewOrder'))
      } catch (_) {
        this.viewOrder = defaultViewOrder
      }
      if (this.viewOrder.length !== 5) {
        this.viewOrder = defaultViewOrder
      }
      this.$cookie.set('viewOrder', JSON.stringify(this.viewOrder), { expires: '1Y' })
      this.$cookie.delete('cards')
    } else {
      this.viewOrder = this.$route.params.viewOrder
    }
  },
  beforeRouteLeave (to, from, next) {
    EventBus.$emit('goSearch')
    next()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/OrderModal.vue